<script lang="ts">
import type { RentersPolicyStatusType } from 'ui/components/renters/enums';
import { sendErrorReport } from 'ui/components/bugsnag/index.vue';

export interface Policy {
  policyNumber: string;
  startDate: string;
  endDate?: string;
  autoRenew: boolean;
  status: RentersPolicyStatusType;
  neverHadCoverage?: boolean;
}
export type RentersSummarySmallUi = {
  policyNumber?: string;
  dates?: string;
  status?: string;
}
</script>
<script setup lang="ts">
defineProps<{
  policy: Policy,
  layout?: 'left' | 'center',
  ui?: RentersSummarySmallUi,
}>();
</script>
<template>
  <div
    :data-cy="`renters-policy-select-option-${policy.policyNumber}`"
    class="text-xs"
  >
    <slot name="policy-number">
      <div :class="['font-semibold', ui?.policyNumber, layout === 'center' ? 'text-center' : 'text-left']">
        {{ policy.policyNumber }}
      </div>
    </slot>
    <UiRentersSummarySmallDates
      :start-date="policy.startDate"
      :end-date="policy.endDate"
      :status="policy.status"
      :auto-renew="policy.autoRenew"
      :never-had-coverage="policy.neverHadCoverage"
      :class="[{ 'justify-center': layout === 'center' }, ui?.dates]"
    />
    <UiRentersSummarySmallStatus
      :status="policy.status"
      :class="[{ 'justify-center': layout === 'center' }, ui?.status]"
      @on-error="sendErrorReport('Renters Policy Summary', 'Invalid status', policy)"
    />
  </div>
</template>
